import React, { useState, useEffect, useContext, useMemo } from "react";
import { Tabs } from 'antd'
import type { TabsProps } from "antd"
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import PlmCost from "./plmCost"
import StructCost from "./structCost"
import HrCost from "./hrCost"
import { useRequest } from "ahooks"
import { getBudgetsDepartmentsApi } from '@/services'
import { CostContext } from "./cost"
import { ProjectDetailContext } from '../constant'
import { k_permission } from "../project"
import PlmCosts from "../plmCosts";

const k_tabKey = {
    exec: "exec",
    struct: "struct",
    hrexec: "hrexec",
    plmcosts: "plmcosts"
}

const Index = () => {
    const params = useParams()
    const projectID = params.projectID || -1

    const { permissions, project } = useContext(ProjectDetailContext)

    const tabItems = useMemo(() => {
        // let items = [{
        //     label: '预算成本执行',
        //     key: k_tabKey.exec,
        //     children: <PlmCost />
        // }]
        let items: any[] = []
        if (permissions && permissions.includes(k_permission.costsStructView)) {
            items = [
                ...items,
                {
                    label: '项目成本结构',
                    key: k_tabKey.struct,
                    children: <StructCost />
                }
            ]
        }
        if (permissions && permissions.includes(k_permission.costsHrExecView)) {
            items = [
                ...items,
                {
                    label: '人力成本执行',
                    key: k_tabKey.hrexec,
                    children: <HrCost />
                }
            ]
        }
        if (project?.profile?.code && permissions && permissions.includes(k_permission.plmcostsView)) {
          items.push({
            key: k_tabKey.plmcosts,
            label: '总包合同一览',
              children: (<PlmCosts project={project} canEdit={permissions.includes(k_permission.plmcostsEdit)} />),
          });
        }
        return items
    }, [permissions, project])

    const [searchParams] = useSearchParams()
    const navigate = useNavigate();
    const [tab, setTab] = useState("")
    useEffect(() => {
        const tabStr = searchParams.get("tab")
        if (tabStr) {
            const item = tabItems.find(v => v.key === tabStr)
            if (item) {
                setTab(item.key)
                return
            }
        }
        if (tabItems.length > 0) {
            setTab(tabItems[0].key)
        }
        
    }, [searchParams])
    const onTabChange: TabsProps['onChange'] = (activeKey) => {
        navigate(`/projects/${projectID}/costs?tab=${activeKey}`);
    };
    const { data: departments = [], loading: departsLoading } = useRequest(getBudgetsDepartmentsApi, {
        defaultParams: [projectID]
    })

    return (
        <CostContext.Provider value={{ departs: departments, departsLoading: departsLoading }}>
            <Tabs
            type="card"
            activeKey={tab}
            items={tabItems}
                destroyOnHidden={true}
            onChange={onTabChange}
            />
        </CostContext.Provider>
    )
}
export default Index